import { CLASSROOM_MODULE_HIDEUNHIDE_MATERIAL } from '../actions';
import { patchSection, patchFolder } from '../api';
import * as classRoomSelectors from '../../selectors/classroom';
import * as materialsSelectors from '../selectors';

const changeVisibilityAction = (status, payload) => ({
  type: CLASSROOM_MODULE_HIDEUNHIDE_MATERIAL,
  status,
  payload,
});

const changeVisibilityStarted = changeVisibilityAction.bind(null, 'started');
const changeVisibilitySuccess = changeVisibilityAction.bind(null, 'success');
const changeVisibilityError = changeVisibilityAction.bind(null, 'error');

const changeVisibility = async (dispatch, state, material, hidden) => {
  const classRoom = classRoomSelectors.currentClassRoomId(state);
  const optimisticPatch = { ...material, hidden };

  dispatch(changeVisibilityStarted({ materialId: material.id }));
  try {
    const patchFunction = material.isFolder ? patchFolder : patchSection;
    const patch = {
      hidden,
      scheduledFor: null,
    };
    const updatedMaterial = !material.id.startsWith('local.')
      ? await patchFunction(classRoom, material.id, patch)
      : optimisticPatch;
    dispatch(changeVisibilitySuccess({ updatedMaterial }));
  } catch (error) {
    dispatch(changeVisibilityError(error));
  }
};

export const hideMaterial = (materialId) => async (dispatch, getState) => {
  const state = getState();
  const material = materialId
    ? materialsSelectors.getMaterial(state, materialId)
    : materialsSelectors.currentSection(state);
  await changeVisibility(dispatch, state, material, true);
};

export const unHideMaterial = (materialId) => async (dispatch, getState) => {
  const state = getState();
  const material = materialsSelectors.getMaterial(state, materialId);
  await changeVisibility(dispatch, state, material, false);
};
